
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/about-us",
      function () {
        return require("private-next-pages/resources/about-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/about-us"])
      });
    }
  